// Stripe payment form (components/StripePaymentElement.js). Stripe translates
// its own fields; these are the strings around them.
export const checkout = {
  en: {
    "checkout.declined":
      "Your card has been declined. Please contact your bank or try a different payment method.",
    "checkout.trialStarted": "Your free trial has started!",
    "checkout.thanks": "Thank you for your purchase!",
    "checkout.startTrial": "Start free trial",
    "checkout.pay": "Pay",
  },
  es: {
    "checkout.declined":
      "Tu tarjeta fue rechazada. Comunícate con tu banco o prueba con otro método de pago.",
    "checkout.trialStarted": "¡Tu prueba gratis comenzó!",
    "checkout.thanks": "¡Gracias por tu compra!",
    "checkout.startTrial": "Empezar prueba gratis",
    "checkout.pay": "Pagar",
  },
  pt: {
    "checkout.declined":
      "Seu cartão foi recusado. Fale com seu banco ou tente outra forma de pagamento.",
    "checkout.trialStarted": "Seu teste grátis começou!",
    "checkout.thanks": "Obrigado pela sua compra!",
    "checkout.startTrial": "Começar teste grátis",
    "checkout.pay": "Pagar",
  },
};
